import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import DesktopWindows from "@material-ui/icons/DesktopWindows";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import DetailsInfo from "./components/info";
import { useBreadcrumbs } from "../../../contexts/breadcrumb";
import { useAttendanceLocalDetailsStyles } from "./styles";
import { useTotemDetails } from "../../../services/api-tansquery/totem/details";


export default function TotemDetails() {
    const history = useHistory();
    const { setBreadcrumbs } = useBreadcrumbs();
    const { id } = useParams<{ id: string }>();
    const { classes } = useAttendanceLocalDetailsStyles();
    const { data: totem } = useTotemDetails(Number(id));

    useEffect(() => {
        setBreadcrumbs((prev) => {
            const homeBreadcrumb = prev.find((_, index) => index === 0);
            return [
                homeBreadcrumb,
                {
                    label: "Totem",
                    path: "/totens",
                    icon: DesktopWindows
                },
                {
                    label: "Informações",
                    path: "",
                }
            ]
        });
    }, [setBreadcrumbs]);

    return (
        <Box className={classes.root}>
            <Box>
                <Button
                    className={classes.backButton}
                    startIcon={<ChevronLeft />}
                    onClick={() => history.goBack()}
                >
                    Voltar
                </Button>
            </Box>
            <DetailsInfo totem={totem} />
        </Box >
    );
}
